<script lang="ts">
    import { cx } from '$lib/utils/cx.js';

    export let small = false;
</script>

<div class="flex items-start text-transparent">
    <div
        class={cx(
            'rounded-full bg-gray-300 animate-pulse',
            small
                ? 'force-w-12 ls:force-w-16 force-h-12 ls:force-h-16'
                : 'force-w-16 ls:force-w-24 force-h-16 ls:force-h-24',
        )}
    />
    <div class="flex-1 overflow-hidden">
        <div
            class="arrow-left arrow-left-t-8 arrow-left-w-10px arrow-left-gray-200 arrow-left-bg-white flex-1 ml-8 bg-white/50 border border-solid border-gray-200 p-4 relative rounded"
        >
            <div>
                <div class={'my-2 flex gap-x-2'}>
                    <div class="text-12 font-bold truncate flex-1">
                        <span class={'bg-gray-300 animate-pulse rounded-md'}
                            >Author name here</span
                        >
                    </div>
                    <div class="italic text-12">
                        <span class={'bg-gray-300 animate-pulse rounded-md'}
                            >3 days ago</span
                        >
                    </div>
                </div>
                <div class="text-14 bg-gray-300 animate-pulse rounded-md">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </div>
            </div>
        </div>
    </div>
</div>
